module.exports = __webpack_public_path__ + "static/media/super-cloud-rgb.a9a3896c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/super-cloud-rgb.png
// module id = 1263
// module chunks = 0